import { useMemo } from "react";
import HighlightGrid from "./components/HighlightGrid";
import calculateHighlights from "./utils/calculateHighlights";
import styles from "./VenuePlannerHighlights.module.css";

const VenuePlannerHighlights = ({
  hotels = [],
  conventionCentres = [],
}) => {
  const highlights = useMemo(() => {
  return calculateHighlights(hotels);
}, [hotels]);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.eyebrow}>
            OUR NETWORK
          </span>

          <h2 className={styles.heading}>
            Explore Our Growing Venue Network
          </h2>

          <p className={styles.subtitle}>
            Discover an extensive network of hotels and event spaces
            across destinations, all in one place.
          </p>
        </div>

        <HighlightGrid highlights={highlights} />
      </div>
    </section>
  );
};

export default VenuePlannerHighlights;